export const SocialLoginAssets = {
  NAVER: 'https://a.travel-assets.com/egds/marks/naver.svg',
};
